import { render, staticRenderFns } from "./goodsAnalysis.vue?vue&type=template&id=52de00ec&scoped=true&"
import script from "./goodsAnalysis.vue?vue&type=script&lang=js&"
export * from "./goodsAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./goodsAnalysis.vue?vue&type=style&index=0&id=52de00ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52de00ec",
  null
  
)

component.options.__file = "goodsAnalysis.vue"
export default component.exports